import { render, staticRenderFns } from "./RechargeHistories.vue?vue&type=template&id=67bc78d4"
import script from "./RechargeHistories.vue?vue&type=script&lang=ts"
export * from "./RechargeHistories.vue?vue&type=script&lang=ts"
import style0 from "./RechargeHistories.vue?vue&type=style&index=0&id=67bc78d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports